import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../Components/Dashboard";
import SignIn from "../Components/LoginAuth/SignIn";
import ForgotPassword from "../Components/LoginAuth/ForgotPassword";
import OTPVerification from "../Components/LoginAuth/OTPVarification";
import NewPassword from "../Components/LoginAuth/NewPassword";
import PublicLayout from "../Layouts/PublicLayout";
import PrivateLayout from "../Layouts/PrivateLayout";
import Layout from "./Layout";
import TermsConditions from "../Components/TermsConditions";
import { Help } from "../Components/Help";
import KycDetailsViewModal from "../Components/MerchantManagement/KYC/KycDetailsViewModal";
import { KycVerification } from "../Components/MerchantManagement/KYC/KycVerification";
import IndustryManagement from "../Components/IndustryManagement";
import Enquiries from "../Components/Enquiries";
import CustomerList from "../Components/CustomerOverview/CustomerList";
import CustomerOverviewDetail from "../Components/CustomerOverview/CustomerOverviewDetail";
import MerchantTransaction from "../Components/MerchantManagement/MerchantTransaction";
import MerchantOverviewDetail from "../Components/MerchantManagement/MerchantOverview/index";
import MerchantOverviewCard from "../Components/MerchantManagement/MerchantOverview/MerchantOverviewCards";
import CardOfferManagement from "../Components/MerchantManagement/CardOfferManagement";
import BannerOfferManagement from "../Components/MerchantManagement/BannerOfferManagement";
import PageNotFound from "../Components/Common/PageNotFound";

const AppRoutes = ({ onProfileUpdate, profileImage, profileName }) => {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<SignIn />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/otpvarification" element={<OTPVerification />} />
        <Route path="/newpassword" element={<NewPassword />} />
      </Route>

      <Route
        element={
          <PrivateLayout />
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/kyc_verification" element={<KycVerification/>} />
        <Route path="/kyc_verification/view_detail" element={<KycDetailsViewModal/>} />
        <Route path="/marchant_overview" element={<MerchantOverviewCard/>} />
        <Route path="/marchant_overview/detail" element={<MerchantOverviewDetail/>} />
        <Route path="/merchant_transection" element={<MerchantTransaction/>} />
        <Route path="/enquiries" element={<Enquiries/>} />
        <Route path="/customer_list" element={<CustomerList/>} />
        <Route path="/customer_overview/detail" element={<CustomerOverviewDetail/>} />
        <Route path="/conditions" element={<TermsConditions />} />
        <Route path="/help" element={<Help />} />
        <Route path="/card-offer_management" element={<CardOfferManagement/>}/>
        <Route path="/banner-offer_management" element={<BannerOfferManagement/>}/>
        <Route path="/industry_management" element={<IndustryManagement/>}/>
        <Route path="*" element={<PageNotFound/>}/>  

      </Route>
    </Routes>
  );
};

export default AppRoutes;
